module.exports = {
  email: 'mehdi.tassoumt@gmail.com',

  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/mehditassoumt/',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/hirako2000',
    },
    {
      name: 'Codepen',
      url: 'https://codepen.io/hirako2000/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/Hirako35007280',
    },
    {
      name: 'jsFiddle',
      url: 'http://jsfiddle.net/user/hirako2000/fiddles/',
    },
  ],

  navLinks: [
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 1000,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
